import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

export default function LegalMaterial({ children, header }) {
  LegalMaterial.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    header: PropTypes.string,
  };
  return (
    <div className="legal-material-page">
      <h1 className="legal-material-page__header">{header}</h1>
      {children}
    </div>
  );
}
